<template>
	<v-card outlined class="pa-2 mt-3" elevation="3">
		<!-- tabs -->
		<v-tabs v-model="tabs" centered>
			<v-tab v-if="userProfile.role !== 'person'">
				{{ editMode ? 'Actividad' : 'Nueva actividad' }}
			</v-tab>
			<v-tab v-if="userProfile.role !== 'person' && editMode">
				Notificationes
			</v-tab>
			<v-tab v-if="editMode || userProfile.role == 'person'">
				Documentos
			</v-tab>
			<v-tab v-if="editMode || userProfile.role == 'person'">
				Notas
			</v-tab>
			<v-tab v-else-if="!editMode">
				Notas
			</v-tab>
		</v-tabs>
		<v-divider class="mb-3" />
		<v-tabs-items v-model="tabs">
			<!-- activity -->
			<v-tab-item v-if="userProfile.role !== 'person'">
				<edit-lodging :close="close" :sendAllNotes="sendAllNotes" />
			</v-tab-item>
			<!-- notifications -->
			<v-tab-item v-if="userProfile.role !== 'person' && editMode">
				<v-card flat>
					<v-card-text v-if="lodgingSelect">
						<template v-if="isToday && editMode && isUser && statePhonePerson == 2">
							<confirmation-button
								:lodging-id="lodgingSelect._id"
								:personId="lodgingSelect.person._id || lodgingSelect.person"
								:placeName="selectedPlace.text"
							/>
							<span
								v-if="lastConfirmationSms && hasPhone"
								class="caption text--secondary pt-2"
							>
								Última respuesta {{ lastConfirmationSms }}<br />
							</span>
						</template>
						<span class="caption text--secondary pt-2" v-else>
							No se puede enviar consultas de estados ni geolocalización <br />
						</span>
						<span class="caption text--secondary pt-2" v-if="!isToday && editMode">
							La actividad no esta dentro del dia de hoy. <br />
						</span>
						<span class="caption text--secondary pt-2" v-if="!hasPhone && editMode">
							La persona asignada a esta actividad, no tiene celular. <br />
						</span>
						<span
							class="caption text--secondary pt-2"
							v-if="hasPhone && statePhonePerson == 0 && editMode"
						>
							El número celular, no ha sido verificado. <br />
						</span>
						<span
							class="caption text--secondary pt-2"
							v-if="hasPhone && statePhonePerson == 1 && editMode"
							>El número celular, esta en proceso de verificación. <br />
						</span>
					</v-card-text>
				</v-card>
			</v-tab-item>
			<!-- documents -->
			<v-tab-item v-if="editMode || userProfile.role == 'person'">
				<resumen-o-t
					:selectedPlace="selectedPlace"
					:person="persons.find(p => p._id === lodgingSelect.person)"
					:lodgingSelect="lodgingSelect"
				/>
				<v-card flat>
					<v-card-text>
						<v-row>
							<v-col>
								<v-btn @click="dialog = true" small color="success">
									Agregar archivo
									<v-icon right>mdi-plus</v-icon>
								</v-btn>
							</v-col>
							<template v-if="userProfile.role == 'person'">
								<v-col>
									<v-btn small color="primary" @click="openFormRRPlagas">
										RR Plagas OT
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
							</template>
						</v-row>
					</v-card-text>
					<v-card-text>
						Se recomienda no ingresar mas de 2 ordenes de trabajo por actividad
						<v-btn
							block
							small
							v-for="(order, i) in orderRRPlagas"
							:key="'agro' + i"
							class="ma-2"
							target="_blank"
							:href="generateWorkOrderLink(order)"
						>
							Orden de trabajo rr plagas {{ i + 1 }}
						</v-btn>
					</v-card-text>
					<v-card-text>
						<v-slide-group
							center-active
							show-arrows
							v-if="lodgingSelect"
							v-model="item"
						>
							<v-slide-item
								v-for="(document, i) in lodgingSelect.documents"
								:key="i"
								v-slot="{ toggle }"
								:value="document.length"
							>
								<v-card
									outlined
									class="ma-4 bgCard"
									height="180"
									width="200"
									color="transparent"
									@click="toggle"
								>
									<v-card-text style="height: 40px;" class="pt-2 pb-0">
										{{
											document.filename
												? cutText(document.filename)
												: 'Sin nombre'
										}}
									</v-card-text>
									<v-divider />
									<v-card-text class="pb-0 pt-2" style="height: 100px">
										<div
											v-if="document.user.name"
											class="caption text--secondary"
										>
											Subido por: {{ cutText(document.user.name) }}
										</div>
										<div class="success--text" style="font-size: 10px">
											Creado el {{ createAt(document.createAt) }}
										</div>
									</v-card-text>
									<v-card-actions style="height: 20px">
										<v-spacer></v-spacer>
										<v-btn
											:href="document.url"
											target="_blank"
											x-small
											color="success"
										>
											Descargar
											<v-icon small right>mdi-download</v-icon>
										</v-btn>
										<v-spacer></v-spacer>
									</v-card-actions>
								</v-card>
							</v-slide-item>
							{{ toggle }}
						</v-slide-group>
					</v-card-text>
				</v-card>
			</v-tab-item>
			<!-- notes -->
			<v-tab-item v-if="editMode || userProfile.role == 'person'">
				<v-card flat>
					<v-card-text class="text-left">
						<div
							style=" overflow: auto;"
							v-if="lodgingSelect && lodgingSelect.notes.length"
							class="note"
						>
							<div v-for="note in notes" :key="note._id">
								<div class="text-capitalize">
									{{ note.sender }} -
									<small>{{ formatDate(note.createdAt) }}</small>
								</div>
								<p class="caption" max-width="200">
									{{ note.text }}
								</p>
							</div>
						</div>
						<v-alert v-else class="tilte text-center">No tienes notas</v-alert>
						<v-textarea
							v-model="note"
							outlined
							filled
							hide-details
							label="Escribir nota"
							counter="1000"
							rows="2"
							:rules="[rules.length(1001)]"
							class="my-1"
							append-icon="mdi-comment"
						></v-textarea>
						<div class="text-center">
							<v-btn
								type="submit"
								color="success"
								small
								@click="submitNotes"
								:loading="loadingSetNotes"
								>Agregar</v-btn
							>
						</div>
					</v-card-text>
				</v-card>
			</v-tab-item>
			<!--Notes TimelineAll -->
			<v-tab-item v-else-if="!editMode">
				<v-card flat>
					<v-card-text class="text-left">
						<div style="height: 100px; overflow: auto;" class="note">
							<div v-for="note in allNotes" :key="note._id">
								<div class="text-capitalize">
									{{ note.sender }} -
									<small>{{ formatDate(note.createdAt) }}</small>
								</div>
								<p class="caption" max-width="200">
									{{ note.text }}
								</p>
							</div>
						</div>
						<v-textarea
							v-model="note"
							label="Escribir nota"
							counter="1000"
							outlined
							rows="2"
							:rules="[rules.length(1001)]"
							class="mt-1"
							append-icon="mdi-comment"
						></v-textarea>
						<div class="text-right">
							<v-btn
								type="submit"
								color="success"
								small
								@click="addNote"
								:loading="loadingSetNotes"
								>Agregar</v-btn
							>
						</div>
					</v-card-text>
				</v-card>
			</v-tab-item>
		</v-tabs-items>
		<footer-lodging v-if="userProfile.role !== 'person'" :close="close" />
		<!-- dialog stepper -->
		<v-dialog v-if="lodgingSelect" v-model="dialog" max-width="550" style="position: relative">
			<upload-documents
				:close="() => (dialog = false)"
				:viewFinal="() => viewFinal()"
				:id="lodgingSelect._id"
			/>
		</v-dialog>
		<v-dialog
			v-model="orderDialog"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card light>
				<v-toolbar dark color="secondary" dense>
					<span class="title">Orden</span>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn dark text @click="() => closeDialogOrder()">
							Cerrar
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-card-text v-if="order" class="px-0">
					<list-urban-plagas
						v-if="order.some(el => el == 'urban-plagas')"
						:workOrder="order"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="orderDialog"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card light>
				<v-toolbar dark color="secondary" dense>
					<span class="title">Orden</span>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn dark text @click="() => closeDialogOrder()">
							Cerrar
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-card-text v-if="order" class="px-0">
					<list-r-r-plagas
						v-if="order.some(el => el == 'rr-plagas')"
						:workOrder="order"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			v-if="formUrbanPlagas"
			v-model="formUrbanPlagas"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card light>
				<v-toolbar dark color="secondary" dense>
					<span class="title">Control de plaga</span>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn dark text @click="closeFormUrbanPlagas">
							Cerrar
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-card-text v-if="lodgingSelect" class="px-0">
					<form-urban-plagas
						:idLodging="lodgingSelect._id"
						:close="closeFormUrbanPlagas"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-if="formRRPlagas"
			v-model="formRRPlagas"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card light>
				<v-toolbar dark color="secondary" dense>
					<span class="title">Control de plaga</span>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn dark text @click="closeFormRRPlagas">
							Cerrar
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-card-text v-if="lodgingSelect" class="px-0">
					<form-r-r-plagas :idLodging="lodgingSelect._id" :close="closeFormRRPlagas" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		ConfirmationButton: () => import('@/components/lodgings/ConfirmationButton'),
		EditLodging: () => import('@/components/lodgings/EditLodging'),
		FooterLodging: () => import('@/components/lodgings/FooterLodging'),
		ListUrbanPlagas: () => import('@/components/lodgings/ListUrbanPlagas'),
		FormUrbanPlagas: () => import('@/components/lodgings/FormUrbanPlagas'),
		FormRRPlagas: () => import('@/components/lodgings/FormRRPlagas'),
		ListRRPlagas: () => import('@/components/lodgings/ListRRPlagas'),
		resumenOT: () => import('@/components/lodgings/resumenOT'),
		UploadDocuments: () => import('@/components/persons/UploadDocuments'),
	},
	props: {
		close: {
			type: Function,
			default: () => null,
		},
	},
	data() {
		return {
			formBiotecPlagas: false,
			formRRPlagas: false,
			formAgroServices: false,
			formCicloUrbano: false,
			formCicloUrbanoPiscinas: false,
			formUrbanPlagas: false,
			orderDialog: false,
			order: null,
			loadingSetNotes: false,
			tabs: 0,
			dialog: false,
			toggle: null,
			item: null,
			note: '',
			rules: {
				length: len => v => (v || '').length < len || `Maximo ${len - 1} caracteres`,
			},
			adminRole: '',
			allNotes: [],
		};
	},
	computed: {
		notes() {
			let notes = this.lodgingSelect.notes;
			return notes.reverse();
		},
		orderCicloUrbano() {
			return this.lodgingSelect.workOrder.filter(order =>
				order.some(el => el == 'ciclo-urbano')
			);
		},
		orderCicloUrbanoPiscinas() {
			return this.lodgingSelect.workOrder.filter(order =>
				order.some(el => el == 'ciclo-urbano-piscinas')
			);
		},
		orderAgroServices() {
			return this.lodgingSelect.workOrder.filter(order =>
				order.some(el => el == 'agro-services')
			);
		},
		orderUrbanPlagas() {
			return this.lodgingSelect.workOrder.filter(order =>
				order.some(el => el == 'urban-plagas')
			);
		},
		orderBiotecPlagas() {
			return this.lodgingSelect.workOrder.filter(order =>
				order.some(el => el == 'biotec-plagas')
			);
		},
		orderRRPlagas() {
			const orders = this.lodgingSelect.workOrder.filter(order => order.type === 'rrplagas');
			return orders;
		},
		person() {
			if (this.persons.length)
				return this.persons.find(
					person =>
						person._id == this.lodgingSelect.person._id ||
						person._id == this.lodgingSelect.person
				);
			return null;
		},
		statePhonePerson() {
			if (this.person) return this.person.isPhoneVerified;
			else return 0;
		},
		hasPhone() {
			if (this.person) {
				if (this.person.phone) return true;
				else return false;
			} else return false;
		},
		isUser() {
			if (this.person) {
				return this.person.isUser;
			} else return false;
		},
		isToday() {
			if (this.lodgingSelect) {
				if (this.lodgingSelect.start && this.lodgingSelect.end)
					return moment().isBetween(
						moment(this.lodgingSelect.start),
						moment(this.lodgingSelect.end),
						'day',
						'[]'
					);
			}
			return false;
		},
		lastConfirmationSms() {
			const lastNotificationsIndex = this.lodgingSelect.userNotifications.length - 1;
			if (lastNotificationsIndex > 0)
				return moment(
					this.lodgingSelect.userNotifications[lastNotificationsIndex].date
				).fromNow();
			return '';
		},
		...mapGetters({
			persons: 'Person/persons',
			lodgingSelect: 'Lodging/lodgingSelect',
			selectedPlace: 'Lodging/selectedPlace',
			editMode: 'Lodging/editMode',
			getPerson: 'Person/person',
		}),
	},
	mounted() {
		this.scrollToElement();
		if (this.userProfile.role === 'person') {
			this.getAdminRole(this.getPerson.idCompany);
		}
	},
	methods: {
		async submitNotes() {
			this.loadingSetNotes = true;
			if (this.note.length < 1001)
				await this.updateNotes({
					currentRoute: this.$route.name,
					lodgingId: this.lodgingSelect._id,
					note: {
						sender: `${this.userProfile.name} ${this.userProfile.lastName}`,
						text: this.note,
					},
				});
			this.note = '';
			this.scrollToElement();
			this.loadingSetNotes = false;
		},
		async sendAllNotes(newLodgings) {
			this.loadingSetNotes = true;
			if (this.note.length < 1001) {
				await this.updateAllNotes({
					lodgings: newLodgings,
					notes: this.allNotes,
				});
			}
			this.loadingSetNotes = false;
		},
		async getAdminRole(id) {
			this.adminRole = await this.fetchAdminProfile(id);
		},
		addNote() {
			this.allNotes.push({
				sender: `${this.userProfile.name} ${this.userProfile.lastName}`,
				text: this.note,
			});
			this.note = '';
			this.scrollToElement();
		},
		cutText(text) {
			if (text.length > 15) {
				return `${text.split('.')[0].substr(0, 18)}...`;
			}
			return text;
		},
		createAt(date) {
			return moment(date).format('lll');
		},
		viewFinal() {
			if (this.lodgingSelect && this.lodgingSelect.documents.length)
				this.item = this.lodgingSelect.documents.length - 1;
		},
		scrollToElement() {
			const el = this.$el.getElementsByClassName('note')[0];
			if (el) {
				el.scrollTop = 0;
			}
		},
		openDialogOrder(data) {
			if (!this.$vuetify.breakpoint.lgAndUp)
				document.getElementById('viewport').setAttribute('content', 'width=900');
			this.orderDialog = true;
			this.order = data.map(item => {
				if (item === null || item === false) return 'Sin info';
				if (item === true) return 'Si';
				else return item;
			});
		},
		closeDialogOrder() {
			document
				.getElementById('viewport')
				.setAttribute('content', 'width=device-width,initial-scale=1.0');
			this.orderDialog = false;
			this.order = null;
		},
		closeFormCicloUrbano() {
			this.formCicloUrbano = false;
			document
				.getElementById('viewport')
				.setAttribute('content', 'width=device-width,initial-scale=1.0');
		},
		closeFormCicloUrbanoPiscinas() {
			this.formCicloUrbanoPiscinas = false;
			document
				.getElementById('viewport')
				.setAttribute('content', 'width=device-width,initial-scale=1.0');
		},
		closeFormBiotecPlagas() {
			this.formBiotecPlagas = false;
			document
				.getElementById('viewport')
				.setAttribute('content', 'width=device-width,initial-scale=1.0');
		},
		closeFormUrbanPlagas() {
			this.formUrbanPlagas = false;
			document
				.getElementById('viewport')
				.setAttribute('content', 'width=device-width,initial-scale=1.0');
		},
		closeFormRRPlagas() {
			this.formRRPlagas = false;
			document
				.getElementById('viewport')
				.setAttribute('content', 'width=device-width,initial-scale=1.0');
		},
		closeFormAgroServices() {
			this.formAgroServices = false;
			document
				.getElementById('viewport')
				.setAttribute('content', 'width=device-width,initial-scale=1.0');
		},
		openFormRRPlagas() {
			if (!this.$vuetify.breakpoint.lgAndUp)
				document.getElementById('viewport').setAttribute('content', 'width=1056');
			this.formRRPlagas = true;
		},
		openFormCicloUrbano() {
			if (!this.$vuetify.breakpoint.lgAndUp)
				document.getElementById('viewport').setAttribute('content', 'width=900');
			this.formCicloUrbano = true;
		},
		openFormBiotecPlagas() {
			if (!this.$vuetify.breakpoint.lgAndUp)
				document.getElementById('viewport').setAttribute('content', 'width=900');
			this.formBiotecPlagas = true;
		},
		openFormCicloUrbanoPiscinas() {
			if (!this.$vuetify.breakpoint.lgAndUp)
				document.getElementById('viewport').setAttribute('content', 'width=900');
			this.formCicloUrbanoPiscinas = true;
		},
		openFormUrbanPlagas() {
			if (!this.$vuetify.breakpoint.lgAndUp)
				document.getElementById('viewport').setAttribute('content', 'width=900');
			this.formUrbanPlagas = true;
		},
		openFormAgroServices() {
			if (!this.$vuetify.breakpoint.lgAndUp)
				document.getElementById('viewport').setAttribute('content', 'width=1100');
			this.formAgroServices = true;
		},
		generateWorkOrderLink(workOrder) {
			return `#/${workOrder.type}/${this.lodgingSelect._id}/work-order/${workOrder.index}`;
		},
		formatDate(date) {
			return moment(date).format('DD-MM-YYYY HH:mm');
		},
		...mapActions({
			updateNotes: 'Lodging/updateNotes',
			fetchAdminProfile: 'User/fetchAdminProfile',
			updateAllNotes: 'Lodging/updateAllNotes',
		}),
	},
};
</script>

<style lang="scss" scoped>
.bgCard {
	background: linear-gradient(180deg, #be66ea38, #487ef947);
}
</style>
